export default __webpack_public_path__ + "static/media/no_image.e9d1a9de.jpg";